export const galleryCopy = {
  en: ["Gallery", "All", "View"],
  fr: ["Galerie", "Tout", "Voir"],
  ru: ["Галерея", "Все", "Смотреть"],
  uk: ["Галерея", "Усі", "Переглянути"],
  de: ["Galerie", "Alle", "Ansehen"],
  it: ["Galleria", "Tutti", "Visualizza"],
  es: ["Galería", "Todo", "Ver"],
  pt: ["Galeria", "Tudo", "Ver"],
  nl: ["Galerij", "Alles", "Bekijken"],
  cs: ["Galerie", "Vše", "Zobrazit"],
  pl: ["Galeria", "Wszystkie", "Zobacz"],
  hu: ["Galéria", "Összes", "Megtekintés"],
  da: ["Galleri", "Alle", "Se"],
  fi: ["Galleria", "Kaikki", "Katso"],
  sv: ["Galleri", "Alla", "Visa"],
  no: ["Galleri", "Alle", "Vis"],
  sk: ["Galéria", "Všetko", "Zobraziť"],
  tr: ["Galeri", "Tümü", "Görüntüle"],
  el: ["Συλλογή", "Όλα", "Προβολή"],
  zh: ["图片库", "全部", "查看"],
  ja: ["ギャラリー", "すべて", "表示"],
  ar: ["معرض الصور", "الكل", "عرض"],
  hi: ["गैलरी", "सभी", "देखें"],
};